import {TranslationServiceInterface} from "../../../../translation-service.interface";
import {SynthesisService} from "../../synthesis.service";
import {FrCaIcsHbeCustomGroupSummaryMapper} from "./fr.ca-ics-hbe.custom-group-summary.mapper";

export class FrCaIcsHbeSynthesisService extends SynthesisService {

    constructor(protected translationService: TranslationServiceInterface) {
        super(new FrCaIcsHbeCustomGroupSummaryMapper(translationService), translationService);
    }
}
